export function formatNumberToIndonesian(num) {
    if (num >= 1000000000000) {
        return (num / 1000000000000).toFixed(0) + ' Trilyun';
    } else if (num >= 1000000000) {
        return (num / 1000000000).toFixed(0) + ' Milyar';
    } else if (num >= 1000000) {
        return (num / 1000000).toFixed(0) + ' Juta';
    } else if (num >= 1000) {
        return (num / 1000).toFixed(0) + ' Ribu';
    } else {
        return num.toString();
    }
}
export function numberWithSeparator(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}